import { render, staticRenderFns } from "./Discuss.vue?vue&type=template&id=4fb3d6fd&scoped=true&"
import script from "./Discuss.vue?vue&type=script&lang=js&"
export * from "./Discuss.vue?vue&type=script&lang=js&"
import style0 from "./Discuss.vue?vue&type=style&index=0&id=4fb3d6fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb3d6fd",
  null
  
)

export default component.exports